import { render, staticRenderFns } from "./BaseTooltip2.vue?vue&type=template&id=e7a254a8"
import script from "./BaseTooltip2.vue?vue&type=script&lang=js"
export * from "./BaseTooltip2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7a254a8')) {
      api.createRecord('e7a254a8', component.options)
    } else {
      api.reload('e7a254a8', component.options)
    }
    module.hot.accept("./BaseTooltip2.vue?vue&type=template&id=e7a254a8", function () {
      api.rerender('e7a254a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/BaseTooltip2.vue"
export default component.exports